export const METERS_IN_MILE = 1609.344;

export function metersToMiles(meters) {
  if (!Number.isFinite(meters)) {
    return NaN;
  }
  return meters / METERS_IN_MILE;
}

export function milesToMeters(miles) {
  if (!Number.isFinite(miles)) {
    return NaN;
  }
  return miles * METERS_IN_MILE;
}

export function formatMiles(meters) {
  if (!Number.isFinite(meters)) {
    return "—";
  }
  const miles = metersToMiles(meters);
  if (!Number.isFinite(miles)) {
    return "—";
  }
  const milesDisplay = miles >= 10 ? miles.toFixed(1) : miles.toFixed(2);
  return `${milesDisplay} mi`;
}
